import { Visibility, VisibilityOff } from "@mui/icons-material";
import { Box, IconButton, InputAdornment, TextField } from "@mui/material";
import { Form, Formik } from "formik";
import { useState } from "react";
import * as yup from "yup";
import PrimaryButton from "../../../../components/buttons/PrimaryButton";

export default function ServiceNowConnectForm({
  onSubmit,
  guideMode,
  initialValues,
}) {
  const [showPassword, setShowPassword] = useState(false);
  const handleClickShowPassword = () => setShowPassword(!showPassword);
  const handleMouseDownShowPassword = () => setShowPassword(!showPassword);

  const formInitialValues = initialValues || {
    instance_url: "",
    username: "",
    password: "",
  };

  const formCheckoutSchema = yup.object().shape({
    instance_url: yup
      .string()
      .url("Must be a valid URL")
      .required("Instance URL is required"),
    username: yup.string().required("Username is required"),
    password: yup.string().required("Password is required"),
  });

  const handleFormSubmit = (values) => {
    onSubmit(values);
  };

  return (
    <Box>
      <Formik
        onSubmit={handleFormSubmit}
        initialValues={formInitialValues}
        validationSchema={formCheckoutSchema}
      >
        {({
          values,
          errors,
          touched,
          handleBlur,
          handleChange,
          handleSubmit,
        }) => (
          <Form onSubmit={handleSubmit}>
            <Box display="grid" mb="20px" gap="10px">
              <TextField
                fullWidth
                variant="filled"
                name="instance_url"
                label="ServiceNow Instance URL"
                placeholder="https://your-instance.service-now.com"
                value={values.instance_url}
                onBlur={handleBlur}
                onChange={handleChange}
                autoComplete="off"
                error={!!touched.instance_url && !!errors.instance_url}
                helperText={
                  touched.instance_url && errors.instance_url
                    ? String(errors.instance_url)
                    : ""
                }
                disabled={guideMode}
              />
              <TextField
                fullWidth
                variant="filled"
                name="username"
                label="Username"
                value={values.username}
                onBlur={handleBlur}
                onChange={handleChange}
                autoComplete="username"
                error={!!touched.username && !!errors.username}
                helperText={
                  touched.username && errors.username
                    ? String(errors.username)
                    : ""
                }
                disabled={guideMode}
              />
              <TextField
                fullWidth
                variant="filled"
                name="password"
                label="Password"
                value={values.password}
                type={showPassword ? "text" : "password"}
                onBlur={handleBlur}
                onChange={handleChange}
                autoComplete="current-password"
                error={!!touched.password && !!errors.password}
                helperText={
                  touched.password && errors.password
                    ? String(errors.password)
                    : ""
                }
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        aria-label="toggle password visibility"
                        onClick={handleClickShowPassword}
                        onMouseDown={handleMouseDownShowPassword}
                      >
                        {showPassword ? <Visibility /> : <VisibilityOff />}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
                disabled={guideMode}
              />
            </Box>
            <Box width={700} display="flex" justifyContent="center">
              <PrimaryButton type="submit" disabled={guideMode}>
                Connect
              </PrimaryButton>
            </Box>
          </Form>
        )}
      </Formik>
    </Box>
  );
}
